document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.getElementById("user-submenu-toggle");
    const submenu = document.getElementById("user-submenu");

    if (toggleButton !== null) {
        toggleButton.addEventListener("click", function (event) {
            event.stopPropagation();

            if (submenu.style.display === "none" || submenu.style.display === "") {
                submenu.style.display = "block";
            } else {
                submenu.style.display = "none";
            }
        });

        document.addEventListener("click", function () {
            if (submenu.style.display === "block") {
                submenu.style.display = "none";
            }
        });

        submenu.addEventListener("click", function (event) {
            event.stopPropagation();
        });
    }
});
